import {
  Typography,
  StyledDiv,
  Spacing,
  Card,
} from '@taleemabad/dsm/components';
import styled from '@emotion/styled';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';

export interface CoachDetailSchool {
  id: string;
  status: string;
  title: string;
  totalTeachers: number;
}

export interface RmCoachDetailsProps {
  coachName: string;
  dateRange: string;
  schools: CoachDetailSchool[];
  onSchoolClick?: (school: CoachDetailSchool) => void;
}

export enum SchoolStatus {
  Incomplete = 'Incomplete',
  Complete = 'Complete',
}

function getStatusVariant(status: string) {
  switch (status) {
    case SchoolStatus.Incomplete:
      return 'textBodySmallSchemesError';
    case SchoolStatus.Complete:
      return 'textBodySmallSecondary';
    default:
      return 'textBodySmallOnSurfaceVariant';
  }
}

export const RmCoachDetails = ({
  coachName,
  dateRange,
  schools = [],
  onSchoolClick,
}: RmCoachDetailsProps) => (
  <StyledDiv
    flexDirection="column"
    width="100%"
    padding="0 0 var(--rk-spacing-xxxxxxxxxxl) 0"
  >
    <Typography variant="textBodyMediumOnSurfaceVariant" textAlign="center">
      {dateRange}
    </Typography>

    <Spacing marginBottom="md" />

    <Typography variant="textBodyLarge">Coach</Typography>
    <Typography variant="textHeadlineMediumLightOnSurface">
      {coachName}
    </Typography>
    <Spacing marginBottom="xl" />
    <StyledCardsContainer>
      {schools.length === 0 ? (
        <>
          <Spacing marginTop="xxxxxxxl" />
          <Typography
            variant="textTitleSmallOnSurfaceVariant"
            textAlign="center"
            color="var(--md-sys-color-on-surface-variant)"
          >
            No schools assigned yet.
          </Typography>
        </>
      ) : (
        schools.map((school) => (
          <Card
            variant="outline"
            minHeight="60"
            key={school.id}
            onClick={() => onSchoolClick?.(school)}
          >
            <Typography variant={getStatusVariant(school.status)}>
              {school.status}
            </Typography>
            <Spacing marginBottom="xs" />
            <Typography variant="textTitleMediumSurface">
              {school.title}
            </Typography>
            <Typography variant="textBodyMediumOnSurfaceVariant">
              Total Teachers: {school.totalTeachers}
            </Typography>
          </Card>
        ))
      )}
    </StyledCardsContainer>
  </StyledDiv>
);

const StyledCardsContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--rk-spacing-md);

  ${mq(BreakpointSizes.desktop)} {
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }
`;
